import React from 'react';

import Spinner from 'Components/Spinner';

export const TableLoading = () => <Spinner isFetching holderTag='div' contentTag='div'/>;
